<template>
  <div>
    <template v-for="(segment, index) in composition">
      <a v-if="segment.type == types.url" :key="index" :href="segment.value" target="_blank"
            class="secondary--text text--darken-1">
        {{ segment.label }}
      </a>
      <v-tooltip v-else-if="segment.type == types.tooltip" :key="index" top>
        <template v-slot:activator="{ on, attrs }">
          <a
            href="#"
            class="font-weight-bold secondary--text text-decoration-none  text--darken-1"
            @click.prevent
            v-bind="attrs"
            v-on="on"
          >
            {{ segment.label }}*
          </a>
        </template>
        <span>{{ segment.value }}</span>
      </v-tooltip>
      <span v-else :key="index">{{ segment.value }}</span>
    </template>
  </div>
</template>

<script>
import {
  getQuestionTextParts,
  questionTextPartType
} from "../constants/Survey";

export default {
  name: "SurveyQuestionText",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    composition() {
      return getQuestionTextParts(this.text);
    },
    types() {
      return questionTextPartType;
    }
  }
};
</script>
